// removed by extract-text-webpack-plugin
module.exports = {"creditCardTypeIcon":"_2GZuV"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/CreditCardTypeIcon/CreditCardTypeIcon.scss
// module id = 370
// module chunks = 0 1